import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';

import { useSelector } from '../store/utils';
import {
  HeatPumpStatus,
  HeatPumpInfoStatus,
} from '../../../core/src/shared/enums';

export const FormattedHeatPumpStatus = () => {
  const [status, subStatus] = useSelector(
    ({ variables }) =>
      [
        get(variables, 'HP_INFO.Status'),
        get(variables, 'HP_INFO.SubStatus'),
      ] as const
  );

  const statusMapping: Record<HeatPumpStatus, ReactNode> = {
    [HeatPumpStatus.Heating]: (
      <FormattedMessage id="hp.status.heating" defaultMessage="Vytápění" />
    ),
    [HeatPumpStatus.HotWater]: (
      <FormattedMessage
        id="hp.status.hot_water"
        defaultMessage="Ohřev teplé vody"
      />
    ),
    [HeatPumpStatus.Cooling]: (
      <FormattedMessage id="hp.status.cooling" defaultMessage="Chlazení" />
    ),
    [HeatPumpStatus.Pool]: (
      <FormattedMessage id="hp.status.pool" defaultMessage="Ohřev bazénu" />
    ),
    [HeatPumpStatus.Inactive]: (
      <FormattedMessage id="hp.status.inactive" defaultMessage="Neaktivní" />
    ),
    [HeatPumpStatus.NotConnected]: (
      <FormattedMessage
        id="hp.status.not_connected"
        defaultMessage="Nelze navázat spojení"
      />
    ),
    [HeatPumpStatus.CompressorBlocked]: (
      <FormattedMessage
        id="hp.status.compressor_blocked"
        defaultMessage="Blokace kompresoru, nízký stav baterie"
      />
    ),
    [HeatPumpStatus.NotLicensed]: (
      <FormattedMessage
        id="hp.status.not_licensed"
        defaultMessage="Tepelné čerpadlo není licencované"
      />
    ),
  };

  const subStatusMapping: Record<HeatPumpInfoStatus, ReactNode> = {
    [HeatPumpInfoStatus.None]: (
      <FormattedMessage id="hp.sub_status.none" defaultMessage=" " />
    ),
    [HeatPumpInfoStatus.ConsumptionRise]: (
      <FormattedMessage
        id="hp.sub_status.consumption_rise"
        defaultMessage="při zvýšení spotřeby"
      />
    ),
    [HeatPumpInfoStatus.ConsumptionPostpone]: (
      <FormattedMessage
        id="hp.sub_status.consumption_postpone"
        defaultMessage="při snížení spotřeby"
      />
    ),
    [HeatPumpInfoStatus.ConsumptionWithFlexibility]: (
      <FormattedMessage
        id="hp.sub_status.consumption_with_flexibility"
        defaultMessage="s flexibilitou"
      />
    ),
    [HeatPumpInfoStatus.NibeNotWritable]: (
      <FormattedMessage
        id="hp.sub_status.nibe_not_writable"
        defaultMessage="- do NIBE nelze zapisovat"
      />
    ),
  };

  return (
    <>
      {statusMapping[status]} {subStatusMapping[subStatus]}
    </>
  );
};
